/* Mona PDP — pergola side-screens configurator + accessory add-ons.

   Rewritten to fix three defects:
   1. Selections are now REMOVABLE — a selected card reopens its dialog with a
      Remove button, and "Save" on an already-configured card replaces the old
      cart line instead of adding a second one.
   2. A running configuration total (pergola + screens + accessories) renders
      under the add-ons and updates with every change.
   3. Cart lines are tracked by LINE KEY, not variant id, and are only cleared
      when the pergola SIZE changes. The old code zeroed cart lines by variant
      id on every option change — silently deleting items customers had added
      earlier, even from other sessions' picks of the same variant.       */
(function () {
  'use strict';
  if (window.__monaPdpAddons) return;
  window.__monaPdpAddons = true;

  function fmtLen(n) { return n.toString() + "'"; }
  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-mona-cart-count], .mona-header__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', !cart.item_count);
      });
    }).catch(function () {});
  }

  /* every cart mutation goes through one queue so operations can't race */
  var cartQueue = Promise.resolve();
  function enqueue(fn) {
    cartQueue = cartQueue.then(fn).catch(function () {});
    return cartQueue;
  }
  function addLine(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty, properties: { '_pergola_addon': '1' } }] })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        var it = (res.items && res.items[0]) || res;
        return it && it.key ? it.key : null;
      });
  }
  function removeLine(key) {
    if (!key) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).catch(function () {});
  }

  function sizeValueFor(root) {
    var pos = root.getAttribute('data-size-pos') || '1';
    var checked = document.querySelector('[data-mona-option][data-option-position="' + pos + '"]:checked')
      || document.querySelector('[data-mona-option][data-option-position="' + pos + '"]');
    return checked ? checked.value : null;
  }
  function dimsFor(root) {
    var s = sizeValueFor(root);
    if (!s) return null;
    var nums = (s.match(/\d+(?:[.,]\d+)?/g) || []).map(function (n) { return parseFloat(n.replace(',', '.')); });
    return nums.length >= 2 ? [nums[0], nums[1]] : (nums.length === 1 ? [nums[0], nums[0]] : null);
  }
  /* fires onSize only when the pergola SIZE actually changes; onAny on every
     variant event (deduped against the old double-listener behaviour) */
  function watchVariant(root, onSize, onAny) {
    var last = sizeValueFor(root);
    function check() {
      var s = sizeValueFor(root);
      if (s !== last) { last = s; onSize(); }
      if (onAny) onAny();
    }
    document.addEventListener('mona:variant-change', check);
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-mona-option]')) check();
    });
  }

  /* ============ RUNNING CONFIGURATION TOTAL ============ */
  var totalBlock = document.querySelector('[data-mona-config-total]');
  var priceMap = {};
  var pm = location.pathname.match(/\/products\/[A-Za-z0-9._-]+/);
  if (pm) {
    fetch(pm[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      (p.variants || []).forEach(function (v) { priceMap[v.id] = v.price; });
      updateTotal();
    }).catch(function () {});
  }
  var screenSel = [];   /* {card, key, id, qty, cents, cfg:{type,color,install}} */
  var addonSel = [];    /* {card, key, id, cents, sel:{...}} */
  function currentVariantId() {
    var el = document.querySelector('[data-mona-variant-id]');
    return el ? parseInt(el.value, 10) : null;
  }
  /* the Add-to-Cart button price also reflects the configuration:
     base variant markup is stashed and restored when no add-ons remain */
  var atcEl = document.querySelector('[data-mona-atc-price]');
  var atcBase = atcEl ? atcEl.innerHTML : null;
  function extrasTotal() {
    return screenSel.reduce(function (s, x) { return s + x.cents * x.qty; }, 0)
         + addonSel.reduce(function (s, x) { return s + x.cents; }, 0);
  }
  function updateAtc(recapture) {
    if (!atcEl) return;
    if (recapture) atcBase = atcEl.innerHTML;   /* variant change rewrote it — that markup is the new base */
    var extras = extrasTotal();
    if (!extras) { if (atcBase != null) atcEl.innerHTML = atcBase; return; }
    var base = priceMap[currentVariantId()];
    if (base == null) return;
    atcEl.textContent = fmtMoney(base + extras);
  }
  function updateTotal() {
    var sc = screenSel.reduce(function (s, x) { return s + x.cents * x.qty; }, 0);
    var ac = addonSel.reduce(function (s, x) { return s + x.cents; }, 0);
    if (totalBlock) {
      if (!sc && !ac) { totalBlock.hidden = true; }
      else {
        var base = priceMap[currentVariantId()];
        totalBlock.hidden = false;
        var el;
        el = totalBlock.querySelector('[data-ct-base]'); if (el) el.textContent = (base != null) ? fmtMoney(base) : '—';
        el = totalBlock.querySelector('[data-ct-screens-row]'); if (el) el.hidden = !sc;
        el = totalBlock.querySelector('[data-ct-screens]'); if (el) el.textContent = fmtMoney(sc);
        el = totalBlock.querySelector('[data-ct-addons-row]'); if (el) el.hidden = !ac;
        el = totalBlock.querySelector('[data-ct-addons]'); if (el) el.textContent = fmtMoney(ac);
        el = totalBlock.querySelector('[data-ct-total]'); if (el) el.textContent = fmtMoney((base || 0) + sc + ac);
      }
    }
    updateAtc(false);
  }
  /* after any variant event, mona-product.js rewrites the ATC price first;
     the debounce collapses the duplicate custom+native events, then we
     recapture that markup as the new base and re-apply the extras */
  var atcTimer = null;
  function onAnyVariantEvent() {
    clearTimeout(atcTimer);
    atcTimer = setTimeout(function () { updateAtc(true); updateTotal(); }, 80);
  }
  document.addEventListener('mona:variant-change', onAnyVariantEvent);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-mona-option]')) onAnyVariantEvent();
  });

  function markCard(card, selected, note) {
    if (!card) return;
    card.classList.toggle('is-selected', selected);
    var plus = card.querySelector('.mona-side-card__plus, .mona-addon-card__plus');
    if (plus) plus.textContent = selected ? '✓' : '+';
    /* accessory cards already have a price span — reuse it for the note */
    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) {
      if (selected && note) priceEl.textContent = note;
      return;                       /* deselect text is restored by refreshCards() */
    }
    var noteEl = card.querySelector('[data-sel-note]');
    if (selected && note) {
      if (!noteEl) {
        noteEl = document.createElement('span');
        noteEl.className = 'mona-side-card__note';
        noteEl.setAttribute('data-sel-note', '');
        card.appendChild(noteEl);
      }
      noteEl.textContent = note;
    } else if (noteEl) noteEl.remove();
  }

  /* ============ SIDE SCREENS ============ */
  document.querySelectorAll('[data-mona-sides]').forEach(function (root) {
    var grid = root.querySelector('[data-sides-grid]');
    var dialog = root.querySelector('[data-sides-dialog]');
    var data = {};
    try { data = JSON.parse(root.getAttribute('data-variants')); } catch (e) {}
    var hasManual = root.getAttribute('data-has-manual') === 'true';
    var hasSolar = root.getAttribute('data-has-solar') === 'true';
    var current = { len: null, qty: 1, type: hasManual ? 'manual' : 'solar', color: 'Anthracite (RAL 7016)', install: 'Between two posts', card: null };
    var cardImage = root.getAttribute('data-card-image');
    var typeImgs = { manual: root.getAttribute('data-img-manual'), solar: root.getAttribute('data-img-solar') };

    function entryFor(card) {
      for (var i = 0; i < screenSel.length; i++) if (screenSel[i].card === card) return screenSel[i];
      return null;
    }
    function findVariant(type, len, color) {
      var list = data[type] || [];
      var lenStr = len.toString();
      var exact = list.filter(function (v) { return v.len === lenStr && v.color === color && v.avail; });
      if (!exact.length) return null;
      var pref = exact.filter(function (v) { return v.install === current.install; });
      return (pref[0] || exact[0]);
    }
    function hasLen(len) {
      var lenStr = len.toString();
      return ['manual', 'solar'].some(function (t) {
        return (data[t] || []).some(function (v) { return v.len === lenStr && v.avail; });
      });
    }
    function resolveSide(len) {
      if (hasLen(len)) return { unit: len, qty: 1 };
      var half = Math.ceil(len / 2);
      if (hasLen(half)) return { unit: half, qty: 2 };
      return null;
    }

    function render() {
      var d = dimsFor(root);
      grid.innerHTML = '';
      if (!d) return;
      var sides = [
        { edge: 'top', len: d[0] }, { edge: 'right', len: d[1] },
        { edge: 'bottom', len: d[0] }, { edge: 'left', len: d[1] }
      ];
      sides.forEach(function (s, i) {
        var res = resolveSide(s.len);
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'mona-side-card' + (res ? '' : ' is-disabled');
        var fig = cardImage
          ? '<span class="mona-side-card__img' + (i % 2 ? ' mona-side-card__img--flip' : '') + '"><img src="' + cardImage + '" alt="" loading="lazy"></span>'
          : '';
        var sub = res && res.qty > 1
          ? '<span class="mona-side-card__note">2 × ' + fmtLen(res.unit) + ' screens</span>'
          : '';
        card.innerHTML = fig +
          '<span class="mona-side-card__plus" aria-hidden="true">+</span>' +
          '<span class="mona-side-card__label">' + fmtLen(s.len) + ' side</span>' + sub;
        if (res) {
          card.addEventListener('click', function () {
            var existing = entryFor(card);
            if (existing) { removeScreenEntry(existing); return; }   /* selected card: tap = remove */
            openDialog(s.len, res, card);
          });
        } else {
          card.disabled = true;
        }
        grid.appendChild(card);
      });
    }

    function buildTypeOpts(preset) {
      var wrap = dialog.querySelector('[data-type-opts]');
      var field = dialog.querySelector('[data-type-field]');
      wrap.innerHTML = '';
      var types = [];
      if (hasManual) types.push(['manual', 'Manual']);
      if (hasSolar) types.push(['solar', 'Solar']);
      types.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mona-sides__opt' + (t[0] === (preset || (types[0] && types[0][0])) ? ' is-active' : '');
        b.setAttribute('data-type-opt', t[0]);
        b.textContent = t[1];
        wrap.appendChild(b);
      });
      field.style.display = types.length > 1 ? '' : 'none';
      current.type = preset || (types.length ? types[0][0] : current.type);
    }
    function setActive(selector, attr, value) {
      dialog.querySelectorAll(selector).forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute(attr) === value);
      });
    }

    function priceText(editing) {
      var v = findVariant(current.type, current.len, current.color);
      var img = dialog.querySelector('[data-dialog-img]');
      var src = (v && v.img) || typeImgs[current.type];
      if (img) { if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; } }
      var addBtn = dialog.querySelector('[data-sides-add]');
      var unavail = dialog.querySelector('[data-sides-unavail]');
      if (v) {
        var qty = current.qty || 1;
        addBtn.childNodes[0].textContent = (editing ? 'Update selection · ' : 'Save selection · ');
        dialog.querySelector('[data-add-price]').textContent = qty > 1
          ? qty + ' × ' + v.price + ' = ' + fmtMoney(v.cents * qty)
          : v.price;
        addBtn.disabled = false; addBtn.style.display = '';
        unavail.hidden = true;
      } else {
        addBtn.style.display = 'none';
        unavail.hidden = false;
      }
    }

    function openDialog(len, res, card) {
      current.len = res.unit; current.qty = res.qty; current.card = card;
      var existing = entryFor(card);
      if (existing) {
        buildTypeOpts(existing.cfg.type);
        current.color = existing.cfg.color;
        current.install = existing.cfg.install;
      } else {
        buildTypeOpts();
        current.color = 'Anthracite (RAL 7016)';
        current.install = 'Between two posts';
      }
      setActive('[data-color-opt]', 'data-color-opt', current.color);
      setActive('[data-install-opt]', 'data-install-opt', current.install);
      dialog.querySelector('[data-sides-remove]').hidden = !existing;
      dialog.querySelector('[data-dialog-side]').textContent = res.qty > 1
        ? fmtLen(len) + " side — fitted as 2 × " + fmtLen(res.unit) + " screens (there is a post in the middle)"
        : fmtLen(len) + ' side';
      priceText(!!existing);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }

    dialog.addEventListener('click', function (e) {
      var typeBtn = e.target.closest('[data-type-opt]');
      if (typeBtn) {
        current.type = typeBtn.getAttribute('data-type-opt');
        setActive('[data-type-opt]', 'data-type-opt', current.type);
        priceText(!!entryFor(current.card)); return;
      }
      var colorBtn = e.target.closest('[data-color-opt]');
      if (colorBtn) {
        current.color = colorBtn.getAttribute('data-color-opt');
        setActive('[data-color-opt]', 'data-color-opt', current.color);
        priceText(!!entryFor(current.card)); return;
      }
      var instBtn = e.target.closest('[data-install-opt]');
      if (instBtn) {
        current.install = instBtn.getAttribute('data-install-opt');
        setActive('[data-install-opt]', 'data-install-opt', current.install);
        priceText(!!entryFor(current.card));
      }
    });
    function closeDialog() { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }
    dialog.querySelector('[data-sides-close]').addEventListener('click', closeDialog);

    function removeScreenEntry(existing) {
      var card = existing.card;
      enqueue(function () {
        return removeLine(existing.key).then(function () {
          screenSel = screenSel.filter(function (x) { return x !== existing; });
          markCard(card, false);
          refreshCartCount(); updateTotal();
        });
      });
    }

    dialog.querySelector('[data-sides-add]').addEventListener('click', function () {
      var v = findVariant(current.type, current.len, current.color);
      if (!v) return;
      var card = current.card;
      var qty = current.qty || 1;
      var cfg = { type: current.type, color: current.color, install: current.install };
      var existing = entryFor(card);
      enqueue(function () {
        return (existing ? removeLine(existing.key) : Promise.resolve())
          .then(function () { return addLine(v.id, qty); })
          .then(function (key) {
            if (existing) {
              existing.key = key; existing.id = v.id; existing.qty = qty; existing.cents = v.cents; existing.cfg = cfg;
            } else {
              screenSel.push({ card: card, key: key, id: v.id, qty: qty, cents: v.cents, cfg: cfg });
            }
            var label = (cfg.type === 'solar' ? 'Solar' : 'Manual') + ' · ' + cfg.color.split(' (')[0] + ' · ' + (qty > 1 ? qty + ' × ' + v.price : v.price);
            markCard(card, true, label + ' — tap to remove');
            refreshCartCount(); updateTotal();
          });
      });
      closeDialog();
    });

    dialog.querySelector('[data-sides-remove]').addEventListener('click', function () {
      var existing = entryFor(current.card);
      if (existing) removeScreenEntry(existing);
      closeDialog();
    });

    function resetScreens() {
      var old = screenSel.slice();
      screenSel = [];
      old.forEach(function (x) { markCard(x.card, false); });
      if (old.length) {
        enqueue(function () {
          return old.reduce(function (p, x) { return p.then(function () { return removeLine(x.key); }); }, Promise.resolve())
            .then(function () { refreshCartCount(); updateTotal(); });
        });
      }
    }

    watchVariant(root,
      function () { resetScreens(); setTimeout(render, 50); },   // size changed: lengths no longer fit
      updateTotal);                                              // any change: base price may differ
    render();
  });

  /* ============ ACCESSORY ADD-ONS ============ */
  document.querySelectorAll('[data-mona-addons]').forEach(function (root) {
    var dialog = root.querySelector('[data-addons-dialog]');
    var sidesRoot = document.querySelector('[data-mona-sides]');
    var sel = {};
    var activeData = null;
    var activeCard = null;

    function entryFor(card) {
      for (var i = 0; i < addonSel.length; i++) if (addonSel[i].card === card) return addonSel[i];
      return null;
    }
    function pergolaSize() { return sidesRoot ? sizeValueFor(sidesRoot) : null; }
    function pergolaDims() { return sidesRoot ? dimsFor(sidesRoot) : null; }

    function validVariants(data) {
      var size = pergolaSize();
      var dims = pergolaDims();
      return data.variants.filter(function (v) {
        if (!v.avail) return false;
        if (data.options.indexOf('Size') !== -1 && size && v.opts['Size'] !== size) return false;
        if (data.options.indexOf('Length') !== -1 && dims) {
          var len = parseFloat((v.opts['Length'] || '').replace(',', '.').replace("'", ''));
          if (!isNaN(len) && dims.indexOf(len) === -1) return false;
        }
        return true;
      });
    }

    function refreshCards() {
      root.querySelectorAll('[data-addon-card]').forEach(function (card) {
        var data = JSON.parse(card.getAttribute('data-addon'));
        var valid = validVariants(data);
        var priceEl = card.querySelector('[data-card-price]');
        if (!valid.length) {
          card.classList.add('is-disabled');
          if (priceEl) priceEl.textContent = 'Not for this size';
        } else {
          card.classList.remove('is-disabled');
          if (priceEl && !entryFor(card)) priceEl.textContent = 'from ' + valid[0].price;
        }
      });
    }

    function currentVariant() {
      if (!activeData) return null;
      var valid = validVariants(activeData);
      var match = valid.filter(function (v) {
        return Object.keys(sel).every(function (k) { return !sel[k] || v.opts[k] === sel[k]; });
      });
      return match[0] || valid[0] || null;
    }

    function renderDialog(editing) {
      var valid = validVariants(activeData);
      var fields = dialog.querySelector('[data-addons-fields]');
      var addBtn = dialog.querySelector('[data-addons-add]');
      var unavail = dialog.querySelector('[data-addons-unavail]');
      dialog.querySelector('[data-addons-title]').textContent = activeData.title;
      var img = dialog.querySelector('[data-addons-img]');
      if (activeData.image) { img.src = activeData.image; img.hidden = false; } else { img.hidden = true; }
      dialog.querySelector('[data-addons-remove]').hidden = !editing;

      if (!valid.length) {
        fields.innerHTML = '';
        addBtn.style.display = 'none';
        unavail.hidden = false;
        dialog.querySelector('[data-addons-match]').textContent = '';
        return;
      }
      unavail.hidden = true;
      addBtn.style.display = '';
      addBtn.childNodes[0].textContent = editing ? 'Update selection · ' : 'Save selection · ';

      var v = currentVariant();
      var auto = [];
      if (activeData.options.indexOf('Size') !== -1 && v) auto.push('Size ' + v.opts['Size']);
      if (activeData.options.indexOf('Length') !== -1 && v) auto.push('Length ' + v.opts['Length']);
      dialog.querySelector('[data-addons-match]').textContent = auto.length ? 'Matched to your pergola: ' + auto.join(' · ') : '';

      fields.innerHTML = '';
      activeData.options.forEach(function (name) {
        if (name === 'Size' || name === 'Length') return;
        var seen = {};
        var opts = [];
        valid.forEach(function (vv) { if (!seen[vv.opts[name]]) { seen[vv.opts[name]] = 1; opts.push(vv.opts[name]); } });
        if (opts.length < 2) return;
        var field = document.createElement('div');
        field.className = 'mona-sides__field';
        var lbl = document.createElement('span');
        lbl.className = 'mona-sides__label';
        lbl.textContent = name;
        field.appendChild(lbl);
        var wrap = document.createElement('div');
        wrap.className = 'mona-sides__opts';
        var DOTS = { 'Anthracite (RAL 7016)': '#3a4045', 'White (RAL 9010)': '#f2f0eb', 'Black': '#141414', 'White': '#f2f0eb' };
        opts.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mona-sides__opt';
          if (name === 'Color' && DOTS[val]) {
            var dot = document.createElement('span');
            dot.className = 'mona-sides__dot';
            dot.style.background = DOTS[val];
            if (val.indexOf('White') === 0) dot.style.border = '1px solid #ccc';
            b.appendChild(dot);
          }
          b.appendChild(document.createTextNode(val.replace(' (RAL 7016)', '').replace(' (RAL 9010)', '')));
          var active = sel[name] ? sel[name] === val : (v && v.opts[name] === val);
          if (active) b.classList.add('is-active');
          b.addEventListener('click', function () { sel[name] = val; renderDialog(editing); });
          wrap.appendChild(b);
        });
        field.appendChild(wrap);
        fields.appendChild(field);
      });

      var cv = currentVariant();
      dialog.querySelector('[data-addons-price]').textContent = cv ? cv.price : '';
    }

    function closeDialog() { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }

    function removeAddonEntry(existing) {
      var card = existing.card;
      enqueue(function () {
        return removeLine(existing.key).then(function () {
          addonSel = addonSel.filter(function (x) { return x !== existing; });
          markCard(card, false);
          refreshCards(); refreshCartCount(); updateTotal();
        });
      });
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-addon-card]');
      if (!card || card.classList.contains('is-disabled')) return;
      var existing = entryFor(card);
      if (existing) { removeAddonEntry(existing); return; }   /* selected card: tap = remove */
      activeData = JSON.parse(card.getAttribute('data-addon'));
      activeCard = card;
      sel = {};
      renderDialog(false);
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    });
    dialog.querySelector('[data-addons-close]').addEventListener('click', closeDialog);

    dialog.querySelector('[data-addons-add]').addEventListener('click', function () {
      var v = currentVariant();
      if (!v) return;
      var card = activeCard;
      var chosen = Object.assign({}, sel);
      var existing = entryFor(card);
      enqueue(function () {
        return (existing ? removeLine(existing.key) : Promise.resolve())
          .then(function () { return addLine(v.id, 1); })
          .then(function (key) {
            if (existing) { existing.key = key; existing.id = v.id; existing.cents = v.cents; existing.sel = chosen; }
            else addonSel.push({ card: card, key: key, id: v.id, cents: v.cents, sel: chosen });
            markCard(card, true, v.price + ' — tap to remove');
            refreshCartCount(); updateTotal();
          });
      });
      closeDialog();
    });

    dialog.querySelector('[data-addons-remove]').addEventListener('click', function () {
      var existing = entryFor(activeCard);
      if (existing) removeAddonEntry(existing);
      closeDialog();
    });

    function resetAddons() {
      var old = addonSel.slice();
      addonSel = [];
      old.forEach(function (x) { markCard(x.card, false); });
      if (old.length) {
        enqueue(function () {
          return old.reduce(function (p, x) { return p.then(function () { return removeLine(x.key); }); }, Promise.resolve())
            .then(function () { refreshCartCount(); updateTotal(); });
        });
      }
    }

    if (sidesRoot) {
      watchVariant(sidesRoot,
        function () { resetAddons(); setTimeout(refreshCards, 50); },
        function () { setTimeout(refreshCards, 50); });
    }
    refreshCards();
  });

  /* ============ QTY / BUY NOW / QUOTE DIALOG ============ */
  var qtyWrap = document.querySelector('[data-mona-qty-wrap]');
  if (qtyWrap) {
    var qty = qtyWrap.querySelector('[data-mona-qty]');
    qtyWrap.querySelector('[data-mona-qty-minus]').addEventListener('click', function () {
      qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1);
    });
    qtyWrap.querySelector('[data-mona-qty-plus]').addEventListener('click', function () {
      qty.value = parseInt(qty.value || '1', 10) + 1;
    });
  }
  var buyNow = document.querySelector('[data-mona-buy-now]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var id = document.querySelector('[data-mona-variant-id]');
      var q = document.querySelector('[data-mona-qty]');
      if (!id || !id.value) return;
      buyNow.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id.value, 10), quantity: q ? parseInt(q.value || '1', 10) : 1 }] })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { buyNow.disabled = false; });
    });
  }
  var quoteDialog = document.querySelector('[data-pgm-quote-dialog]');
  if (quoteDialog) {
    document.querySelectorAll('[data-pgm-quote-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof quoteDialog.showModal === 'function') quoteDialog.showModal(); else quoteDialog.setAttribute('open', '');
      });
    });
    quoteDialog.querySelector('[data-pgm-quote-close]').addEventListener('click', function () {
      if (quoteDialog.close) quoteDialog.close(); else quoteDialog.removeAttribute('open');
    });
  }
})();
